module.exports = __webpack_public_path__ + "static/media/fruits.84551bf7.png";